import { useFormik } from "formik";
import { get, isEmpty } from "lodash";
import { useTranslation } from "react-i18next";
import useZipCodeCities from "shared/hooks/useZipCodeCities";
import { NAME_SPACES } from "shared/locales/constants";
import { CONTACT_POINT_SYSTEM } from "utils/constants";
import {
  bindInputProps,
  bindWebTextFieldInputProps,
} from "utils/helpers/input";
import ActionButtons from "../Components/ActionButtons";
import DataProtection from "../Components/DataProtection";
import Header from "../Components/Header";
import Input from "../Components/Input";
import Layout from "../Components/Layout";
import Select from "../Components/Select";
import validation from "./validation";

function View({ telecoms, onNext, onBack }) {
  const { t } = useTranslation();

  const { submitForm, values, ...formProps } = useFormik({
    initialValues: { telecoms },
    onSubmit: onNext,
    validationSchema: validation(
      t(`${NAME_SPACES.ERRORS}:VALIDATIONS`, { returnObjects: true }),
    ),
  });
  const zipCode = get(
    values,
    `telecoms.${CONTACT_POINT_SYSTEM.ZIP_CODE}.value`,
  );
  const { cities, loading: citiesLoading } = useZipCodeCities(zipCode);

  return (
    <Layout>
      <Header
        title="Pourriez-vous préciser <b>votre adresse ?</b>"
        highlight="votre adresse ?"
        subtitle="Votre localisation"
        onBack={onBack}
      />
      <div className="miltis-form">
        <div className="miltis-form__container">
          <div className="miltis-form__row">
            <Input
              placeholder={"Numéro et voie"}
              label={"Numéro et voie"}
              {...bindWebTextFieldInputProps({
                name: `telecoms.${CONTACT_POINT_SYSTEM.ADDRESS}.value`,
                values,
                ...formProps,
              })}
            />
            <Input
              placeholder={"Lieu – Dit"}
              label={"Lieu – Dit"}
              {...bindWebTextFieldInputProps({
                name: `telecoms.${CONTACT_POINT_SYSTEM.ADDRESS_LOCATION}.value`,
                values,
                ...formProps,
              })}
              optional
            />
          </div>
          <div className="miltis-form__row">
            <Input
              disabled
              placeholder={"ex : 69001"}
              label={"Code postal"}
              {...bindInputProps({
                name: `telecoms.${CONTACT_POINT_SYSTEM.ZIP_CODE}.value`,
                values,
                ...formProps,
              })}
            />
            <Select
              showSearch
              loading={citiesLoading}
              options={cities}
              placeholder={"Sélectionnez ..."}
              label={"Ville"}
              {...bindInputProps({
                name: `telecoms.${CONTACT_POINT_SYSTEM.CITY}.value`,
                values,
                ...formProps,
              })}
            />
          </div>
          <div className="miltis-form__row">
            <Input
              placeholder={"Appartement / étage"}
              label={"Appartement / étage"}
              {...bindWebTextFieldInputProps({
                name: `telecoms.${CONTACT_POINT_SYSTEM.COMPLEMENT}.value`,
                values,
                ...formProps,
              })}
              optional
            />
            <Input
              placeholder={"Résidence / Bâtiment"}
              label={"Résidence / Bâtiment"}
              {...bindWebTextFieldInputProps({
                name: `telecoms.${CONTACT_POINT_SYSTEM.RESIDENCE}.value`,
                values,
                ...formProps,
              })}
              optional
            />
          </div>
          <ActionButtons
            disabled={
              !get(values, `telecoms.${CONTACT_POINT_SYSTEM.ADDRESS}.value`) ||
              !isEmpty(formProps.errors)
            }
            onNext={submitForm}
            onBack={onBack}
            buttonText="Continuer"
          />
          <DataProtection />
        </div>
      </div>
    </Layout>
  );
}

export default View;
